import React from 'react';
import { footerItems } from '../../../utils/helpers';
import styles from './Footer.module.scss';

const Footer = React.forwardRef((props, ref) => {

  const scrollToForm = () => {
    ref.current.scrollIntoView();
    ref.current.focus();
  };

  return (
    <div className={styles.footer_container}>
      <div className={styles.footer_inner}>
        <div className={styles.footer_content}>
          <div className={styles.footer_logo}>
            <a href="https://play.google.com/store/apps/details?id=com.rocketcharge&hl=en_IN" target="_blank" rel="noopener noreferrer">
              <img
                src="https://static.frizza.in/frizza/offer/banner/96219f68-7571-48d0-91ba-2a002d0dc01b.png"
                alt="Frizza"
                loading="lazy"
              />
            </a>
          </div>
          <ul className={styles.footer_items}>
            {footerItems.map((item, idx) => (
              <li key={`ft-${idx}`}>
                {idx === 0 ? (
                  <span style={{ cursor: 'pointer' }} onClick={scrollToForm}>
                    {item.name}
                  </span>
                ) : (
                  <a
                    href={item.link}
                    target='_blank'
                    style={{ textDecoration: 'none', color: '#d9dbe1' }}
                  >
                    {item.name}
                  </a>
                )}
              </li>
            ))}
          </ul>
          <div className={styles.footer_copyrights}>
            <span>© 2022 Frizza. All rights reserved</span>
          </div>
        </div>
        <div className={styles.link_group}>
          <div className={styles.footer_links}>
            <span>Follow us on:</span>
            <div className={styles.links}>
              <a
                href='https://www.facebook.com/frizza.recharge/'
                target='_blank'
              >
                <img
                  src='https://static.frizza.in/frizza/offer/banner/1ee38355-3e6a-49da-809f-f853a11f6abd.png'
                  alt='Facebook'
                  loading='lazy'
                />
              </a>
              <a href='https://twitter.com/frizza12' target='_blank'>
                <img
                  src='https://static.frizza.in/frizza/offer/banner/fd0ce78f-314b-4da7-9f14-0be32328bd61.png'
                  alt='Twitter'
                  loading='lazy'
                />
              </a>
              <a href='https://www.instagram.com/frizza_india/' target='_blank'>
                <img
                  src='https://static.frizza.in/frizza/offer/banner/c0f1693e-c0f8-4aa2-a5da-a80d1d6065f9.png'
                  alt='Instagram'
                  loading='lazy'
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Footer;
